<ng-container *ngIf="!!control.errors?.serverError">
  <mat-error *ngFor="let error of control.getError('serverError').errors"> {{ error }} </mat-error>
</ng-container>

<mat-error *ngIf="control.touched && !!control.hasError('required')">{{ 'This field is required' }}</mat-error>
